import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Instagram, Facebook, Mail, Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function SocialSection() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14 bg-charcoal text-ivory">
      <div className="container-wide text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 mb-6 text-cream/50">
            <a href="mailto:info@sampaolicreazioni.it" className="font-body text-sm flex items-center gap-2 hover:text-cream transition-colors">
              <Mail className="w-4 h-4" />
              info@sampaolicreazioni.it
            </a>
            <a href="tel:+393487630428" className="font-body text-sm flex items-center gap-2 hover:text-cream transition-colors">
              <Phone className="w-4 h-4" />
              +39 348 763 0428
            </a>
          </div>
          <p className="font-body text-cream/70 mb-6 max-w-md mx-auto">
            {t('social.followUs')}
          </p>
          <div className="flex items-center justify-center gap-4">
            <Button variant="heroOutline" size="lg" asChild>
              <a href="https://www.instagram.com/sampaoli_italian_creations/" target="_blank" rel="noopener noreferrer">
                <Instagram className="w-4 h-4 mr-2" />
                Instagram
              </a>
            </Button>
            <Button variant="heroOutline" size="lg" asChild>
              <a href="https://www.facebook.com/sampaolicreazioni" target="_blank" rel="noopener noreferrer">
                <Facebook className="w-4 h-4 mr-2" />
                Facebook
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}